// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".order-state{padding:0.5rem 1rem;position:relative}.order-state::after{content:'';border-right:1px solid var(--border-color);position:absolute;left:calc(50% - 1px);top:0;bottom:0}\n", ""]);
// Exports
module.exports = exports;
